export enum PromoVoucherType {
	Voucher = 'Voucher',
	Refund = 'Refund',
}
